import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { SectionColor, SectionMinHeight } from '../../models/page-section';

@Component({
    selector: 'page-section',
    templateUrl: './page-section.component.html',
    styleUrls: ['./page-section.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class PageSectionComponent implements OnInit {

    /** Determine page-section theme color (background, button, text etc.) */
    @Input() color: SectionColor = SectionColor.BLACK;
    /** Determine a page-section min height, if content doesn't require it to be as tall as wanted */
    @Input() minHeight: SectionMinHeight = null;
    /** Set true to stack subsections at tablet width (default is mobile width) */
    @Input() stackTablet: boolean = false;
    /** Set true to stack subsection bottom-up (default is top-down) */
    @Input() wrapReverse: boolean = false;
    /** Set true if page-section contains other page-sections */
    @Input() parent: boolean = false;

    // Expose to view
    public SectionColor = SectionColor;

    constructor() { }

    ngOnInit(): void { }

}
